import {OverlayTrigger, Tooltip} from "react-bootstrap";
import React from "react";
import C from "helpers/HelpConstants";
import {HelpAbility} from "helpers/HelpAbility";

const ServiceCrudTableRow = ({el, i, editData, deleteData}) => {
    let myAbilities = HelpAbility();
    let {code, name, endpoint, /* description, */ isVisible, _id} = el;

    const style = {
        td: {
            padding: "15px"
        },
        cell1: {
            maxWidth: '250px', 
            whiteSpace: 'normal', 
            wordWrap: 'break-word',
            padding: "15px"
        },
        cell2: {
            padding: "15px"
        },
        row1: {
            borderBottom: "1px solid #c1b2b2"
        }
    }

    return (
        <tr style={style.row1} key={code}>
            <th style={style.cell2} scope="row">{i + 1}</th>
            <td style={style.cell1}>{code}</td>
            <td style={style.cell}>{name}</td>
            <td style={style.cell1}>{endpoint}</td>
            <td style={style.cell2}>{isVisible ? 'Si' : 'No'}</td>
            {myAbilities.hasAny([C.A.SERVICE.UPDATE, C.A.SERVICE.DELETE]) && <td>
                {myAbilities.has(C.A.SERVICE.UPDATE) && <OverlayTrigger placement="top"
                                                                        overlay={<Tooltip
                                                                            id="tooltip-top">Editar</Tooltip>}>
                    <button type="button" className="btn btn-sm btn-success me-2"
                            onClick={() => editData(el)}>
                        <i className="bi bi-pencil-square"/></button>
                </OverlayTrigger>}
                {myAbilities.has(C.A.SERVICE.DELETE) && <OverlayTrigger placement="top"
                                                                        overlay={<Tooltip
                                                                            id="tooltip-top">Eliminar</Tooltip>}>
                    <button type="button" className="btn btn-sm btn-danger"
                            disabled={!el.canDelete} onClick={() => deleteData(_id)}>
                        <i className="bi bi-trash"/></button>
                </OverlayTrigger>}
            </td>}
        </tr>
    );
}
export default ServiceCrudTableRow;
